/**
 * SettingsSection - Sliding settings panel for ScrollWizard
 * Accessible from the left nav menu
 */
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ProfileModal from '../../components/modals/ProfileModal';

const SettingsSection = ({
  isOpen,
  onClose,
  onTournamentsClick,
  onResetClick,
  onQRCodeClick,
  onExportPDFClick,
  onSignOutClick,
  onLoginClick,
  isSyncing,
  lastSyncTime
}) => {
  const { currentUser, guestMode } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  const handleAction = (callback) => {
    onClose();
    callback && callback();
  };

  const userName = currentUser ? currentUser.email : 'Invité';

  return (
    <>
      {isOpen && <div className="settings-overlay" onClick={onClose}></div>}
      <ProfileModal isOpen={showProfile} onClose={() => setShowProfile(false)} />

      <div className={`settings-panel ${isOpen ? 'open' : ''}`}>

        <div className="settings-panel-header">
          <h2 className="settings-panel-title">
            <i className="bi bi-sliders"></i>
            Paramètres
          </h2>
          <button className="settings-panel-close" onClick={onClose} aria-label="Fermer">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="settings-panel-body">

          {/* Compte */}
          {userName && (
            <div className="settings-section">
              <div className="settings-section-title">Compte</div>
              <div
                className="settings-user-info"
                onClick={!guestMode && currentUser ? () => { onClose(); setShowProfile(true); } : undefined}
                style={!guestMode && currentUser ? { cursor: 'pointer' } : undefined}
              >
                <i className={`bi ${currentUser ? 'bi-person-circle' : 'bi-person-fill-slash'}`}></i>
                <span className="settings-user-name">{userName}</span>
                {!currentUser && <span className="settings-badge">Invité</span>}
                {currentUser && <i className="bi bi-chevron-right ms-auto"></i>}
              </div>

              {currentUser && (
                <div className="settings-sync-status">
                  {isSyncing ? (
                    <>
                      <span className="spinner-border spinner-border-sm"></span>
                      <span>Synchronisation...</span>
                    </>
                  ) : lastSyncTime ? (
                    <>
                      <i className="bi bi-cloud-check-fill"></i>
                      <span>Sauvegardé à {lastSyncTime.toLocaleTimeString('fr-FR')}</span>
                    </>
                  ) : null}
                </div>
              )}

              {onSignOutClick && (
                <button className="settings-btn settings-btn-danger" onClick={() => handleAction(onSignOutClick)}>
                  <i className={`bi ${currentUser ? 'bi-box-arrow-right' : 'bi-box-arrow-in-right'}`}></i>
                  {currentUser ? 'Se déconnecter' : 'Se connecter'}
                </button>
              )}
            </div>
          )}

          {/* Tournois */}
          {(onTournamentsClick || onResetClick) && (
            <div className="settings-section">
              <div className="settings-section-title">Tournois</div>
              {onTournamentsClick && (
                <button className="settings-btn" onClick={() => handleAction(onTournamentsClick)}>
                  <i className="bi bi-folder"></i>
                  Mes tournois
                </button>
              )}
              {onResetClick && (
                <button className="settings-btn settings-btn-reset" onClick={() => handleAction(onResetClick)}>
                  <i className="bi bi-arrow-clockwise"></i>
                  Nouveau tournoi
                </button>
              )}
            </div>
          )}

          {/* Partager */}
          {onQRCodeClick && (
            <div className="settings-section">
              <div className="settings-section-title">Partager</div>
              <button className="settings-btn" onClick={() => handleAction(onQRCodeClick)}>
                <i className="bi bi-qr-code"></i>
                QR Code
              </button>
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default SettingsSection;
